import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row, Table, Badge, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEdit,
  faSearch,
  faEraser,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import "./styles.scss";


import Button from "components/_base/Button";
import ModalConfirmarDelete from "components/ModalConfirmarDelete";
import TablePagination from "components/TablePagination";
import { Context } from "context/AuthContext";
import { useAlert } from "context/AlertContext";

import { DELETE_QUESTAO, GET_LIST_QUESTAO_PARCIAL } from "services/Questao";
import { GET_CATEGORIA_ARVORE } from "services/Categoria";

import HtmlPreview from "components/HTMLExtract";
import CategoriaSelector from "components/SelectCategorias";

const ContentAdminQuestao = () => {
  const { showLoader } = useContext(Context);
  const options = [
    { value: "1", label: "Fácil" },
    { value: "2", label: "Médio" },
    { value: "3", label: "Difícil" },
  ];

  const valorInicial = {
    id: 0,
    categoriasId: [],
    enunciado: [], // enunciado
    dificuldade: [],
    PageSize: 25,
    PageNumber: 1,
  };

  const [showModal, setShowModal] = useState(false);
  const [questaoToDelete, setQuestaoToDelete] = useState(null);
  const [pageData, setPageData] = useState({
    totalPages: 0,
    totalRows: 0,
  });
  const [pageCurrent, setPageCurrent] = useState(1);
  const [questoes, setQuestoes] = useState({});
  const [categorias, setCategorias] = useState([]);
  const [filtro, setFiltro] = useState(valorInicial);
  const [data, setData] = useState(false);
  const [filtroLimpo, setFiltroLimpo] = useState(false);

  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const handleEdit = (questao) => {
    navigate(`/admin/questao/registro?id=${questao.id}`);
  };

  const handleDeleteModal = (questaoId) => {
    setQuestaoToDelete(questaoId);
    setShowModal(true);
  };

  const handleDelete = async (questaoId) => {
    showLoader(true);
    const result = await DELETE_QUESTAO(questaoId);

    if (result) {
      showAlert("Questão excluída com sucesso!", "success");
      setFiltro(valorInicial);
      setQuestoes([]);
      setPageData({
        totalPages: 0,
        totalRows: 0,
      });
      setData(!data);
      setShowModal(false);

    } else {
      showAlert(result.errors, "danger");
      setShowModal(false);
    }
    showLoader(false);
  };

  const handleNovaQuestao = () => {
    navigate(`/admin/questao/registro`);
  };

  const handleFiltroChange = async (e) => {
    const { name, value } = e.target;
    setFiltro({
      ...filtro,
      [name]: value ? value : [],
    });
  };

  const handleChangePageNumber = (pageNumber) => {
    setFiltro((prevFiltro) => ({
      ...prevFiltro,
      PageNumber: pageNumber,
    }));

  };

  useEffect(() => {
    if (filtro.PageNumber !== pageCurrent) {
      handleSaveFilter();
      setPageCurrent(filtro.PageNumber);  // Atualiza o controle da página atual
    }
  }, [filtro.PageNumber]); // O useEffect será acionado sempre que filtro.PageNumber mudar



  const handleClearFilter = () => {
    showLoader(true);
    setFiltro(valorInicial);
    setQuestoes([]);
    setPageData({
      totalPages: 0,
      totalRows: 0,
    });
    setFiltroLimpo(true);
    setData(!data);
    showLoader(false);
  };



  const handleSaveFilter = async (e) => {

    showLoader(true);
    const params = {
      ...filtro,
    };
    const data = await GET_LIST_QUESTAO_PARCIAL(params);

    if (data.value.data.length === 0) {
      setData(true);
    }
    setQuestoes(data.value.data);
    setPageData({
      totalPages: data.value.totalPages,
      totalRows: data.value.totalRows,
    });
    showLoader(false);
  };

  useEffect(() => {
    (async () => {
      showLoader(true);

      // Carrega apenas as categorias ao abrir a página
      const dataTipoFiltro = await GET_CATEGORIA_ARVORE();
      setCategorias(dataTipoFiltro.value);

      showLoader(false);
    })();
  }, []);

  const handleCategoriasChange = (categorias) => {
    setFiltro({
      ...filtro,
      CategoriasId: categorias,
    });
    setFiltroLimpo(false);
  };

  return (
    <React.Fragment>
      <ModalConfirmarDelete
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setQuestaoToDelete(null);
        }}
        handleDelete={() => handleDelete(questaoToDelete)}
      />
      <div className="admin-questao-container">
        <div className="admin-header">
          <h1>Questões</h1>
          <hr />
        </div>
        <div className="admin-questao-content-wrapper">
          <div className="admin-questao-content">
            <Button className={"btn-nova-questao"} onClick={handleNovaQuestao}>
              <FontAwesomeIcon icon={faPlus} className="btn-icon" />
              Nova Questão
            </Button>
            <hr />
            <Form className="responsive ms-3">
              <Form.Group as={Row} className="col-md-8 rbutil">
                {/* <Col sm="3">
                  <Form.Label column className=" mb-3">
                    Id
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="questaoId"
                    type="text"
                    readOnly
                    disabled
                    value={filtro.questaoId}
                  />
                </Col> */}
              </Form.Group>
              {/* <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className="mb-3">
                    Enunciado
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="nome"
                    type="text"
                    onChange={handleFiltroChange}
                  />
                </Col>
              </Form.Group> */}
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className="mb-3">
                    Categorias
                  </Form.Label>
                </Col>
                <Col>
                  <CategoriaSelector
                    categorias={categorias}
                    onCategoriasChange={handleCategoriasChange}
                    filtroLimpo={filtroLimpo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className="mb-3">
                    Dificuldade
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Select
                    name="dificuldade"
                    value={
                      options.find(
                        (option) =>
                          option.value === filtro.dificuldade.toString()
                      )?.value || ""
                    }
                    onChange={handleFiltroChange}>
                    <option value="">Selecione a dificuldade</option>
                    {options.map((option) => (
                      <option
                        key={option.value}
                        value={option.value.toString()}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="2"></Col>
                <Col sm="6" className="d-flex justify-content-start">
                  <Button
                    className="btn-filtro me-3"
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault(); // Evita que o form seja submetido
                      handleSaveFilter();
                    }}>
                    <FontAwesomeIcon icon={faSearch} className="btn-icon" />
                    Filtrar
                  </Button>
                  <Button
                    className="btn-filtro"
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClearFilter();
                    }}>
                    <FontAwesomeIcon icon={faEraser} className="btn-icon" />
                    Limpar filtro
                  </Button>
                </Col>
              </Form.Group>
            </Form>
            <hr />
            <Table responsive="sm" bsPrefix="admin-questao-table">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Enunciado</th>
                  <th>Categorias</th>
                  <th>Dificuldade</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {questoes.length > 0 ? (
                  questoes.map((questao) => (
                    <tr key={questao.id + 1}>
                      <td>{questao.id}</td>
                      <td>
                        {!questao.enunciado ? (
                          "-"
                        ) : (
                          <HtmlPreview
                            htmlContent={questao.enunciado}
                            mode="list"
                          />
                        )}
                      </td>
                      <td>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="d-flex justify-content-center">
                          {questao.categorias.map((questaoCategoria) => (
                            <Badge
                              bg="secondary"
                              text="white"
                              key={questaoCategoria.id}>
                              {questaoCategoria.nome}
                            </Badge>
                          ))}
                        </Stack>
                      </td>
                      <td>
                        {questao.dificuldade === 1
                          ? "Fácil"
                          : questao.dificuldade === 2
                            ? "Médio"
                            : "Difícil"}
                      </td>
                      <td>
                        <div className="btns-container">
                          <Button
                            className="btn-questao"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDeleteModal(questao.id);
                            }}>
                            <FontAwesomeIcon icon={faTrash} size="xs" />
                            {""}
                          </Button>
                          <Button
                            className="btn-questao"
                            onClick={() => handleEdit(questao)}>
                            <FontAwesomeIcon icon={faEdit} size="xs" />
                            {""}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : data ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Nenhuma questão encontrada
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </Table>
            <hr />
            <div className="pagination">
              <TablePagination
                pageNumber={filtro.PageNumber}
                setPageNumber={handleChangePageNumber}
                totalPages={pageData.totalPages}
                totalRows={pageData.totalRows}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentAdminQuestao;
